import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Handles drag-drop for moving files into folders
export default class extends Controller {
  static targets = ["card"]
  static values = { id: Number, url: String, highlightRing: String }

  dragOver(event) {
    // Only accept internal upload drags, not native file drops from Finder/Explorer
    if (!this.isUploadMove(event)) {
      return
    }

    event.preventDefault()
    this.cardTarget.classList.add('ring-2', this.highlightRingValue, 'shadow-lg')
  }

  dragLeave(event) {
    event.preventDefault()
    this.cardTarget.classList.remove('ring-2', this.highlightRingValue, 'shadow-lg')
  }

  // A file from Finder/Explorer falls through to the page's file-drop, which uploads it
  async drop(event) {
    if (this.isUploadMove(event)) {
      event.preventDefault()
      event.stopPropagation()
      this.cardTarget.classList.remove('ring-2', this.highlightRingValue, 'shadow-lg')

      const uploadId = event.dataTransfer.getData('application/x-upload-id')
      const updateUrl = event.dataTransfer.getData('application/x-upload-folder-url')

      if (!uploadId || !updateUrl) return

      const url = updateUrl.replace('/ID/', `/${uploadId}/`)

      const response = await patch(url, {
        body: JSON.stringify({ folder_id: this.idValue }),
        contentType: 'application/json',
        responseKind: 'turbo-stream'
      })

      if (!response.ok) {
        console.error('Error moving upload to folder:', response.statusCode)
        this.dispatch('error', { detail: { message: 'Failed to move file to folder' } })
        this.cardTarget.classList.remove('ring-2', this.highlightRingValue, 'shadow-lg')
      }
    }
  }

  isUploadMove(event) {
    return event.dataTransfer.types.includes('application/x-upload-id')
  }
}
